import universal from '../../universal';
import errors from './errors';

export default {
    //#region ERRORS
    "username taken": "Nume de utilizator deja folosit",
    //#endregion

    create: "creare",
    update: "actualizare",
    delete: "ștergere",
    search: "Căutare",
    load: "Încărcare",
    no_file_loaded: "Niciun fișier încărcat",

    created: "Creat",
    insert: "Inserat",
    not: "Nu",
    show_hide: "Afișare/Ascundere",
    change: "Schimbă",
    visibility: "Vizibilitate",
    polygon: "Poligon",
    make_active: "Activează",
    make_deactivate: "Dezactivează",
    enable: "Activează",
    disable: "Dezactivează",
    choose: "Alege",
    select: "Selectează",
    apply: "Aplică",
    rows: "Rânduri",
    rows_visibility: "Vizibilitate Rânduri",
    existent: "Existent",
    existents: "Existente",
    unexistents: "Inexistente",
    interventions_list: "Listă Intervenții",
    from: "de la",
    to: "până la",
    row: "Rând",
    rows: "Rânduri",
    elements: "Elemente",

    errors,
    universal,

    home: 'Pagina principală',
    test: 'Test',

    field_data_survey: 'Calificări',
    field_data_monitor: 'Monitor Calificări',
    export: 'Exportă',
    import: 'Importă',
    imported: 'Importat',
    fixed_network: 'Rețea Fixă',
    import_export: 'Import/Export',
    infoworks_export: 'Export Infoworks',
    dat_export: 'Export Dat',

    network_analysis: 'Analiză Rețea',
    lab_analytics: 'Analize Laborator',
    performances: 'Performanțe',
    trash_by_statistics: 'Statistici Trash-By',

    monitor: 'Monitor',
    consumption_monitor: 'Monitor Consumuri',
    district_monitor: 'Monitor District',
    pressure_monitor: 'Monitor Presiune',
    realtime_monitor: 'Monitor în Timp Real',

    operating_tools: 'Instrumente Operaționale',
    user_registries: 'Registre Utilizatori',
    route_analysis: 'Analiză Trasee',
    logical_paths: 'Trasee Logice',

    workforcemanagement: 'Gestionare Personal',
    replacement_interventions: 'Intervenții de Înlocuire',
    planning: 'Planificare',

    synchronization: 'Sincronizare',
    qualifications_sync: 'SYNC Calificări',
    replacements_sync: 'SYNC Înlocuiri',
    walk_by_drive_by_sync: 'SYNC Walk-by/Drive-by',
    WFM_sync: 'SYNC WFM',
    work_force_management: 'Gestionare Forță de Muncă',

    work_progress_status: 'Stadiu Progres Lucrări',

    "e-mail": "e-mail",
    wrong_email_password: "e-mail sau parolă greșite",
    login: "Autentificare",
    username: "Nume utilizator",
    Lastname: "Nume",
    Firstname: "Prenume",
    Role: "Rol",
    password: "Parolă",
    log_in_into_your_account: "Autentifică-te în contul tău",
    forgot_password: "Ai uitat parola?",
    reset_password: "Resetează parola",
    reset: "Resetează",
    back_to_login: "Înapoi la autentificare",
    password_request_completed: 'Cererea de resetare a parolei a fost finalizată cu succes.',
    check_your_inbox: 'Verifică-ți căsuța de e-mail.',
    didnt_receive_email: 'Nu ai primit e-mailul?',
    send_again: 'Trimite din nou',
    repeat_password: "Repetă parola",
    password_reset_request_failed_or_expired: 'Cererea de resetare a parolei a eșuat sau a expirat.',
    password_reset_successfully: 'Parola a fost resetată cu succes!',
    logout: "Deconectare",

    editor: "Editare/Vizualizare",
    viewer: "Doar Vizualizare",
    disabled: "Dezactivat",

    active: "Activ",
    replaced: "Înlocuit",
    delivered: "Livrat",
    fixed: "Reparat",
    on_fixing: "În Reparație",
    on_returning: "În Returnare",
    on_delivering: "În Livrare",
    broken: "Defect",
    returned: "Returnat",

    ValidFrom: "Valabil De La",
    ValidTo: "Valabil Până La",
    Status: "Stare",
    OrderRef: "Referință Comandă",
    DateDelivered: "Data Livrării",
    alarm: 'Alarmă',
    alarms: 'Alarme',
    alarmsDictionary: {
        no_alarm: 'FĂRĂ ALARMĂ',
        BF: 'FLUX INVERS',
        PE: 'PERSISTENȚĂ',
        BX: 'BATERIE',
        FM: 'SENZOR',
        TP: 'SABOTAJ',
        EX: 'CONSUM EXCESIV',
        EM: 'CONSUM RIDICAT',
        RS: 'RESETARE',
        DF: 'FLUX DIRECT',
        TK: 'RESTABILIRE SABOTAJ',
        RT: 'RESETARE',
        CR: 'EROARE FIRMWARE',
        PM: 'MAGNET PROGRAMARE',
        MG: 'SABOTAJ MAGNETIC',
        MC: 'SABOTAJ MECANIC',
        RV: 'MONTAT INVERS',
        AD: 'AER DETECTAT',
        BP: 'CONDUCTĂ SPARTĂ',
        DR: 'USCAT',
        MT: 'METROLOGIE',
        SS: 'SISTEM',
        WQ: 'CALITATEA APEI',
        PF: 'OPRIT',
        LT: 'TEMPERATURĂ SCĂZUTĂ',
        PX: 'PERSISTENȚĂ EXCESIVĂ',
        PP: 'PERSISTENȚĂ ANTERIOARĂ',
        PI: 'SCURGERE INTERMITENTĂ',
        122: 'RĂU-PLATNIC',
        242: 'ÎN REZILIERE',
        342: 'REZILIAT',
        306: 'ELIMINAT',
        132: 'ALARMĂ NECUNOSCUTĂ',
        116: 'ÎNLOCUIT',
        206: 'ELIMINAT',
        999: 'ALARMĂ NECUNOSCUTĂ',
        ICSE: 'ÎN CURS DE ÎNCETARE',
        CNFA: 'ÎNCETAT DE FACTURAT',
        CFAT: 'ÎNCETAT FACTURAT',
        ICSO: 'ÎN CURS DE SUSPENDARE',
        SOSP: 'SUSPENDAT',
        1: 'STARE SERVICIU 1',
        2: 'STARE SERVICIU 2',
        3: 'STARE SERVICIU 3',
        ES: 'CONDUCTĂ GOALĂ'
    },

    utilities: 'Utilități',
    meter: 'Contor',
    meters: 'Contoare',
    smart_meter: 'Contor Inteligent',
    non_smart: 'Non-Inteligent',
    towns: 'Localități',
    municipalities: 'Localități',
    valid_readings: 'Citiri Valide',
    readings: 'Citiri',
    active_users: 'Utilizatori Activi',

    brand: 'Marcă',
    brands: 'Mărci',

    communication: 'Comunicare',
    communication_type: 'Tip Comunicare',

    device_type: 'Tip Dispozitiv',

    successfully_added: 'Adăugat cu succes!',
    successfully_updated: 'Actualizat cu succes!',
    successfully_removed: 'Eliminat cu succes!',
    successfully_created: 'Creat cu succes!',
    successfully_imported: 'Importat cu succes!',

    server_error: 'Eroare de Server.',

    pick_a_date: 'Alege o dată',
    date_format: 'zz/ll/aaaa',
    confirm: 'Confirmă',
    selected_days: 'Zile selectate',

    all_towns: 'Toate localitățile',
    all_municipalities: 'Toate localitățile',

    failed_update_no_changes: `Actualizare eșuată.\r\nNicio modificare efectuată asupra înregistrării.`,

    last_30_days: 'Ultimele 30 de zile',
    last_7_days: 'Ultimele 7 zile',

    language: 'Limbă',
    back: 'Înapoi',
    cancel: 'Anulează',

    really_want_logout: 'Chiar dorești să te deconectezi?',

    demo: 'Demo',

    error_loading_menu: 'Eroare la încărcarea meniului lateral',
    error_logout: 'Eroare la închiderea sesiunii curente',
    error_saving_language: 'Eroare la salvarea limbii alese',

    "Lavorazione Sospesa": "Procesare Suspendată",
    "Sostituito": "Înlocuit",
    "Mancata Rimozione": "Eliminare Eșuată",
    "Mancata Sostituzione": "Înlocuire Eșuată",
    "Non Lavorato": "Neprocesat",
    "Rimosso": "Eliminat",

    save: 'Salvează',

    plan: 'Plan',

    Terminal: 'Terminal',

    installation: 'Instalare',
    repair: 'Reparație',
    replacement: 'Înlocuire',
    removal: 'Eliminare',
    reading: 'Citire',
    georeferencing: 'Georeferențiere',

    already_present: 'Deja Existent',

    you_must_select_an_intervention_type: 'Trebuie mai întâi să selectezi un tip de intervenție',

    add_to_new_route: 'Adaugă la traseu nou',
    add_to_existing_route: 'Adaugă la traseul selectat',
    add_selected: 'Adaugă Selectate',
    remove_selected: 'Elimină Selectate',

    empty_plan: 'Golește Planul',

    unprocessed: 'Neprocesat',
    attempted_processing: 'Procesare Încercată',
    suspended: 'Suspendat',
    processed: 'Procesat',

    select_a_list: 'Selectează o listă',
    select_operator: 'Selectează operator',

    identity_code: 'Cod Identitate',
    accountholder: 'Titular Cont',
    email: 'E-mail',
    telephone: 'Telefon',

    registry_details: 'Detalii Registru',
    intervention: 'Intervenție',

    geo: 'Geo',
    geo_data: 'Date Geografice',
    latitude: 'Latitudine',
    longitude: 'Longitudine',
    altitude: 'Altitudine',

    ciu: 'CIU',
    codiceUtente: "CIU",
    idModulo: "Modul",
    intestatario: "Titular Cont",
    indirizzo: "Adresă",
    matricola: "Număr de Serie",
    idTipoUtenza: "ID Localitate",
    lat: "Latitudine",
    lng: "Longitudine",
    statoInstallazione: "Instalat",
    rowNumber: "Nr. Rând",
    plan_id: "ID Plan",

    supply_code: 'Cod Furnizare',

    intervention_type: 'Tip Intervenție',
    intervention_status: 'Stare Intervenție',

    old_brand: 'Marcă Veche',
    new_brand: 'Marcă Nouă',
    old_serial: 'Serie Veche',
    new_serial: 'Serie Nouă',
    old_reading: 'Citire Veche',
    old_reading_date: 'Data Citirii Vechi',
    new_reading: 'Citire Nouă',
    digits_number: 'Număr de Cifre',
    seal_code: 'Cod Sigiliu',
    valve: 'Vană',

    anomaly: "Anomalie",
    anomaly_notes: "Notă Anomalie",

    intervention_specifics: 'Detalii Intervenție',
    intervention_result: 'Rezultat Intervenție',
    result: 'Rezultat',

    district: 'District',
    address: 'Adresă',
    municipality: 'Localitate',

    old_location: 'Poziție Veche',
    new_location: 'Poziție Nouă',

    miscellaneous: 'Diverse',

    causal: 'Cauzal',
    note: 'Notă',
    notes: 'Note',

    annotation: 'Adnotare',
    annotations: 'Adnotări',

    all_plans: 'Toate Planurile',
    edit_intervention: 'Editează Intervenție',

    exportation: 'Export',
    importation: 'Import',

    preview: 'Previzualizare',
    parameters: 'Parametri',

    select_exportation: 'Selectează Export',
    start_date: 'Data de Început',
    end_date: 'Data de Sfârșit',
    archived_at: 'Data Arhivării',
    status: 'Stare',
    date: 'Dată',

    witness: 'Nume și Prenume Martor',

    separator: 'Separator',
    format: 'Format',

    trash_by_tools: 'Instrumente Trash-By',
    trash_by_stats: 'Statistici Trash-By',
    walk_by_drive_by_tools: 'Instrumente Walk-By/Drive-By',
    assignment: 'Atribuire',
    district_metering: 'District Metering',
    geotool: 'Geotool',
    intervention_management: 'Gestionare Intervenții',

    press_shift_space_to_switch_working_mode: "Pentru a schimba modul de lucru, apasă ",
    designer_mode: 'Mod Proiectare',
    viewer_mode: 'Mod Vizualizare',

    procedures: 'Proceduri',

    add: 'Adaugă',
    remove: 'Elimină',
    edit: 'Editează',

    created_at: 'Data Creării',
    updated_at: 'Data Modificării',

    route_generator: 'Generator de Trasee Logice',
    house_number: 'Număr Casă',
    serial_number: 'Număr de Serie',
    serial: 'Serie',
    identification_number: 'Număr de Identificare',

    create_path: 'Creează Traseu',
    edit_path: 'Editează Traseu',

    name: 'Nume',
    surname: 'Nume de Familie',
    firstname: 'Prenume',
    lastname: 'Nume de Familie',

    operator: 'Operator',
    anomaly: 'Anomalie',
    anomaly_notes: 'Note Anomalie',
    type: 'Tip',
    supply_type: 'Tip Furnizare',

    intervention_date: 'Data Intervenției',
    intervention_start_date: 'Data Începerii Intervenției',
    intervention_end_date: 'Data Finalizării Intervenției',

    all_photos: 'Toate Fotografiile',

    gallery: 'Galerie',
    logs: 'Jurnale',

    you_have_to_select_a_route: 'Trebuie să selectezi un traseu!',

    ok: 'Ok',
    no: 'Nu',
    yes: 'Da',

    follow_center: 'Urmărește Centrul',
    generated_routes: 'Trasee Generate',

    photo: 'Fotografie',
    photos: 'Fotografii',

    management: 'Gestionare',

    administrator: 'Administrator',
    admin: 'Administrator',

    delete: 'Șterge',

    location: 'Poziție',
    group: 'Grup',
    odi: 'OL',
    id: 'ID',

    period: 'Perioadă',

    module: 'Modul',

    end_users: 'Utilizatori Finali',

    create_route: 'Creează traseu',
    insert_interventions: 'Inserare intervenții pe plan existent',
    by_changing_selection_lose_your_progress_proceed: 'Schimbând selecția vei pierde tot progresul.\nContinui?',

    delete_route: 'Șterge traseu',
    reset_routes: 'Resetează trasee',

    are_you_sure_wanna_proceed: `Ești sigur că vrei să continui?`,
    are_you_sure_wanna_delete_route: 'Ești sigur că vrei să ștergi traseul selectat?',
    are_you_sure_wanna_reset_routes: 'Ești sigur că vrei să ștergi toate traseele generate?',
    are_you_sure_wanna_delete_this_photo: 'Ești sigur că vrei să ștergi această fotografie?',

    tips: 'Sfaturi',
    press_ctrl_and_click_to_draw_selection_area: 'Apasă Ctrl și dă clic pentru a trasa o zonă de selecție.',
    double_click_to_reset_selection_area: 'Dă dublu clic pentru a reseta zona de selecție.',

    notice_date: 'Data Notificării',

    end_user: 'Utilizator Final',

    transmission: 'Transmisie',
    transmissions: 'Transmisii',

    environment: 'Mediu',
    newMeter: 'Contor Nou',
    signatureUser: 'Semnătura Clientului',
    oldMeter: 'Contor Vechi',

    category: 'Categorie',
    select_a_category: 'Selectează o Categorie',

    import_list: 'Importă Listă',

    lists: 'Liste',
    map: 'Hartă',

    accepted_files: 'Fișiere Acceptate',

    drag_and_drop_file_here: 'Trage și plasează un fișier aici',

    kpi: 'KPI',

    stay_logged_in: 'Rămâi conectat',

    code: 'Cod',
    device_not_registered: 'Dispozitiv neînregistrat',
    check_email_for_code: 'Verifică-ți e-mailul și introdu codul pentru a putea accesa',

    you_can_try_login_again_in: `Poți încerca din nou autentificarea în`,

    yesterday: 'Ieri',
    realtime: 'Timp real',

    red_meters: 'Contoare Citite',
    active_alarms: 'Alarme Active',

    visualization: 'Vizualizare',

    reset_selection: 'Resetează Selecția',

    tabular: 'Tabelar',
    archive: 'Arhivă',

    store: 'Arhivează',
    stored: 'Arhivat',
    stored_s: 'Arhivate',
    restore: 'Restaurează',

    are_you_sure_wanna_delete_plan: 'Ești sigur că vrei să ștergi planul?',
    deleting_plan_info: 'Continuând cu eliminarea, atribuirile operatorilor vor fi anulate și nu va mai fi posibilă restaurarea planului.',
    are_you_sure_wanna_archive_plan: 'Ești sigur că vrei să arhivezi planul?',
    archiving_plan_info: 'Continuând cu arhivarea, atribuirile operatorilor vor fi anulate și nu va mai fi posibilă vizualizarea intervențiilor.',
    are_you_sure_wanna_restore_plan: 'Ești sigur că vrei să restaurezi planul?',

    proceeding_operation_misalignments_exports: 'Continuând operațiunea s-ar putea produce dezalinieri în exporturi.',

    warning: 'Atenție',
    plans: 'Planuri',

    plan_assignment: 'Atribuire Plan',

    available: 'Disponibil',
    availables: 'Disponibile',

    stored_plans: 'Planuri Arhivate',

    assign_or_remove_plan_before_change_operator: <>Atribuie sau Elimină <span className='text-success'>planurile</span> pentru Operatorul curent înainte de a putea schimba selecția.</>,

    assign_plans: 'Atribuie Planuri',

    are_you_sure_wanna_delete_list: 'Ești sigur că vrei să ștergi lista?',
    assigned: 'Atribuit',
    unassigned: 'Neatribuit',

    empty_selection: 'Golește selecția',
    create_new: 'Creează nou',
    add_move: 'Adaugă/Mută',
    interventions: 'Intervenții',
    selected: 'Selectat',
    selected_s: 'Selectate',
    move: 'Mută',

    list_name: 'Nume Listă',
    plan_name: 'Nume Plan',

    diameter: 'Diametru',
    diameter_mm: 'Diametru (mm)',

    seal: 'Sigiliu',

    //Customization InterventionManagementATENA
    provincia: 'Provincie',
    posizione_contatore: 'Poziție Contor',
    luogo_contatore: 'Locație Contor'
};
